import {Fragment, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';
import {logoutUser} from '../../../redux/actions/auth';
import {ANONYMOUS, AUTHENTICATED, OK} from '../../../redux/constants';
import {fetchStudentData} from '../../../redux/actions/student';
import {fetchData} from '../../../utils/fetch';

function AuthHeader(props) {
  useEffect(
    () => fetchData(props.fetchStudentData),
    [props.fetchStudentData]
  );
  const history = useHistory();
  const nextURL = `${history.location.pathname}${history.location.search.replace('&', ';')}`;

  if (props.authStatus === ANONYMOUS) {
    return (
      <Fragment>
        <Button as={Link} to={`/login?next=${nextURL}`} content='ورود'/>
        <Button as={Link} to='/register' content='ثبت نام'/>
      </Fragment>
    );
  }
  const isAuthenticated = props.authStatus === AUTHENTICATED;
  return (
    <Fragment>
      <Button
        loading={!isAuthenticated || !props.name}
        disabled={!isAuthenticated || !props.name}
        as={Link}
        to='/profile'
        content={props.name}
      />
      <Button
        negative
        loading={!isAuthenticated}
        disabled={!isAuthenticated}
        content='خروج'
        onClick={props.logoutUser.bind(null, history)}
      />
    </Fragment>
  );
}

AuthHeader.propTypes = {
  authStatus: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fetchStudentData: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired
};

function mapStateToProps({auth, user}) {
  return {
    authStatus: auth.status,
    name: (user.status === OK) ? `${user.data.firstName} ${user.data.lastName}` : ''
  };
}


export default connect(mapStateToProps, {fetchStudentData, logoutUser})(AuthHeader);
